import { kit } from './strings'
import './PageLoader.css'

/**
 * The whole page is waiting.
 *
 * `LoadingState` is a PANEL's busy state — it sits inside a card whose title and
 * frame are already on screen, so a small spinner is all it needs. Opening a
 * page is a different moment: there is nothing on screen yet, and a 34px spinner
 * alone in a 700px column reads as a stall rather than as work in progress.
 *
 * Same two marks as everything else in the kit, at page scale: the emerald and
 * gold arcs turning against each other, a soft accent disc breathing behind
 * them, and one indeterminate line under the label. Determinate would be a lie —
 * nothing here knows how far along a route chunk or a fetch is.
 *
 * `full` is for the one case where the loader IS the document: a route whose
 * whole shell is still being fetched, so there is no header, no rail and no page
 * column to sit in the middle of. Without it the emblem lands a third of the way
 * down an otherwise blank viewport.
 *
 * @param {{label?: string, full?: boolean}} props
 */
export default function PageLoader({ label = kit.loading, full = false }) {
  return (
    <div
      className={`page-loader${full ? ' page-loader--full' : ''}`}
      data-testid="page-loader"
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <span className="page-loader__mark" aria-hidden="true">
        <i className="page-loader__arc" />
        <i className="page-loader__arc" />
        <i className="page-loader__core" />
      </span>

      <p className="page-loader__label">
        <bdi>{label}</bdi>
      </p>

      <span className="page-loader__track" aria-hidden="true">
        <i />
      </span>
    </div>
  )
}
